export default "__VITE_ASSET__BK9q5Fzx__"